<script setup lang="ts">
const props = withDefaults(defineProps<{
  isMobile?: boolean
}>(), {
})
const googleButton = ref()
const { googleClientId } = useRuntimeConfig().public
const { t, locale } = useI18n()
const localeMap: any = {
  zh: 'zh_CN',
  en: 'en', // 中文
  pt: 'pt_BR', // 葡萄牙语（巴西）的另一种可能写法
}
function initializeGoogleSignIn() {
  const isZhLocale = locale.value === 'zh'
  const googleLocale = localeMap[locale.value] || 'en'
  window.google.accounts.id.initialize({
    client_id: googleClientId,
    callback: handleCredentialResponse,
    locale: googleLocale, // ✅ 设置语言（支持 'zh_CN', 'en', 'ja' 等）
  })
  window.google.accounts.id.renderButton(
    googleButton.value,
    {
      locale: googleLocale, // ✅ 设置语言（支持 'zh_CN', 'en', 'ja' 等）
      type: 'standard', // 按钮样式：standard / icon
      size: 'large', // 大小：small / medium / large
      shape: 'rectangular', // 形状：rectangular / circle / pill / tall
      theme: 'outline', // 主题：outline / filled_blue
      width: props.isMobile ? '290' : isZhLocale ? 314 : 334, // 按钮宽度
      logo_alignment: 'center',
    },
  )
  window.google.accounts.id.prompt()
}
const { refetchUserInfo } = useLogin()
const { $request } = useNuxtApp()
const { getPromotionCode } = useRegistrationPromotionCode()
const loading = defineModel('loading')
async function getUerInfoById(idToken) {
  try {
    loading.value = true
    await $request('/user/binding', {
      method: 'GET',
      params: {
        idToken,
        promotionCode: getPromotionCode(),
        terminalInfo: sessionStorage.getItem(constants.LATESET_REFERRER_SESSIONSTORAGE_KEY),
      },
    })
    Message.success(t('登录成功'))
    await refetchUserInfo()
  }
  catch (err) {
    console.error('登录失败:', err)
    Message.error(t('登录失败'))
  }
  finally {
    loading.value = false
  }
}
// 处理登录成功
function handleCredentialResponse(response) {
  const idToken = response.credential
  getUerInfoById(idToken)
}

onMounted(() => {
  const script = document.createElement('script')
  script.src = 'https://accounts.google.com/gsi/client'
  script.async = true
  script.defer = true
  script.onload = initializeGoogleSignIn
  document.head.appendChild(script)
})

onBeforeUnmount(() => {
  const googleScript = document.querySelector('script[src*="accounts.google.com"]')
  if (googleScript)
    document.head.removeChild(googleScript)
})
</script>

<template>
  <div ref="googleButton" class="gala-google-btn" />
</template>

<style scoped>
:deep(.nsm7Bb-HzV7m-LgbsSe) {
  border-radius: 8px !important;
  height: 50px !important;
}
</style>
